import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consultores',
  templateUrl: './consultores.component.html',
  styleUrls: ['./consultores.component.scss']
})
export class ConsultoresComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
